(function () {
    'use strict';
    app.service('contactUsservice', ['$http', '$q', 'AuthenticationService', '$rootScope', '$cookies',
    function ($http, $q, authenticationService, $rootScope, $cookies) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;
        this.sendContactFormToEspectra = function (userData) {
            deferred = $q.defer();
            $http.post(serviceBase + "sendContactFormToEspectra?emailID=" + userData.emailId + "&username=" + userData.username + "&message=" + userData.message)
                           .then(function (response) {
                               deferred.resolve(response);
                           })
                        .catch(function (err, status) {
                            deferred.resolve(err);
                        });
            return deferred.promise;
        }

    }
    ]);
})();